import React from "react";
import "./skeleton.scss";

interface SkeletonTextProps {
  variant: "text";
}

interface SkeletonShapeProps {
  variant: "rect" | "circle";
  width: number;
  height: number;
}

type SkeletonProps = SkeletonTextProps | SkeletonShapeProps;

export default function Skeleton(props: SkeletonProps) {
  let style: any = {};
  if (props.variant !== "text") {
    style.width = props.width+"%";
    style.height = props.height;
  }

  return <div className={`Skeleton Skeleton-${props.variant}`} style={style} />;
}